// src/components/ui/GradientText.tsx
import React, { ElementType, ComponentPropsWithoutRef } from 'react';

// 使用泛型來確保元素類型的正確處理
type GradientTextProps<E extends ElementType = 'span'> = {
  as?: E;
  className?: string;
  children: React.ReactNode;
} & ComponentPropsWithoutRef<E>;

// 使用泛型組件定義
const GradientText = <E extends ElementType = 'span'>({ 
  children, 
  className = '', 
  as, 
  ...props 
}: GradientTextProps<E>) => {
  const Component = as || 'span';
  
  return (
    <Component 
      className={`text-gradient-primary ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default GradientText;